/**
 * @title useSession
 * @description
 * @properties
 * @author 2034263
 * @history
 *   - [2025-09-30] 초기 작성
 */

// React 모듈
import { useCallback } from 'react';

// 내부 라이브러리 모듈
import { useSessionService, useUserContext } from 'scbk-services';

import type { LoginInfo } from '../types';

/**
 * 공통 유저/세션 기능
 *
 * @returns
 */
export const useSession = () => {
  const { isLoginUser, getCommonContext, getAdditionalContext } = useUserContext(); // 유저정보 컨텍스트

  // 세션 hook
  const { getSessionInfo, executeExtendSession } = useSessionService({
    onExecuteLogoutOptions: {
      onError: () => {
        console.log('useSession - executeLogout - onError');
      },
    },
    onExtendSessionOptions: {
      onError: () => {
        console.log('useSession - onExtendSessionOptions - onError');
      },
    },
  });

  const isLogin = useCallback(() => {
    return isLoginUser();
  }, [isLoginUser]);

  const extendSession = useCallback(() => {
    if (!isLogin()) {
      console.warn('useSession > extendSession - not Found Session');
    }
    // 세션연장 실행
    executeExtendSession();
  }, [isLogin, executeExtendSession]);

  /**
   * 로그인 세션 조회(오남용 금지)
   * @param keys : 세션 조회 대상
   */
  const getLoginInfo = useCallback(
    async (keys: string[]): Promise<LoginInfo> => {
      const result = await getSessionInfo(
        { keys },
        {
          onSuccess: () => {
            console.log('useSession > getLoginInfo - success');
          },
          onError: () => {
            console.log('useSession > getLoginInfo - error');
          },
        },
      );

      console.log('useSession > getLoginInfo - result : ', result);

      if (!result?.sessionInfos) {
        return {};
      }

      const loginInfo: LoginInfo = Object.fromEntries(
        result?.sessionInfos.map((s) => [s.key, s.value]),
      );

      return loginInfo;
    },
    [getSessionInfo],
  );

  /**
   * 유저 컨텍스트 정보 조회
   */
  const getUserInfo = useCallback(() => {
    const userInfo = {
      ...getCommonContext(),
      ...getAdditionalContext(),
    };

    return userInfo;
  }, [getCommonContext, getAdditionalContext]);

  return {
    isLogin,
    extendSession,
    getLoginInfo,
    getUserInfo,
  };
};
